<template>
  <div>
    <Cep
        :zipcode="cep.zipcode"
        v-on:cepData="cepData"
    />
    <v-row dense>
      <v-col class="col-12 col-sm-8 col-md-10">
        <v-text-field
            filled
            dense
            label="Rua"
            autocomplete="street"
            name="street"
            v-model="cep.street"
            :error-messages="errors.street"
            prepend-inner-icon="mdi-format-text"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-4 col-md-2">
        <v-text-field
            filled
            dense
            label="Numero"
            autocomplete="number"
            name="number"
            v-model="number"
            prepend-inner-icon="mdi-format-text"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-12 col-md-6">
        <v-text-field
            filled
            dense
            label="Complemento"
            autocomplete="complement"
            name="complement"
            v-model="complement"
            :error-messages="errors.complement"
            prepend-inner-icon="mdi-format-text"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-4 col-md-2">
        <v-text-field
            readonly
            filled
            dense
            label="Bairro"
            autocomplete="district"
            name="district"
            v-model="cep.district"
            prepend-inner-icon="mdi-format-text"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-4 col-md-2">
        <v-text-field
            readonly
            filled
            dense
            label="Cidade"
            autocomplete="city"
            name="city"
            v-model="cep.city"
            prepend-inner-icon="mdi-format-text"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-4 col-md-2">
        <v-text-field
            readonly
            filled
            dense
            label="UF"
            autocomplete="stateShort"
            name="stateShort"
            v-model="cep.state_short"
            prepend-inner-icon="mdi-format-text"
            hide-details="auto"
            placeholder=" "
            type="text"
        ></v-text-field>
      </v-col>
    </v-row>
    <div
        class="mt-2 bgalpha pa-2 text-right"
    >
      <v-btn
          v-show="credential"
          color="gray"
          dark
          @click="$emit('Step', 2);"
          :loading="editState"
          class="mr-2"
      >
        Voltar
      </v-btn>
      <v-btn
          color="success"
          @click="addressEdit()"
          :loading="editState"
      >
        {{ credential ? 'continuar' : 'salvar' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import Cep from './Cep';

  export default {
    props: {
      endpoint_load: String,
      endpoint_edit: String,
      payload: Object,
      credential: Boolean
    },
    components: {
      Cep
    },
    mounted() {
      this.addressLoad();
    },
    data() {
      return {
        errors: [],
        editState: false,
        id: null,
        cep: {
          zipcode: null,
          street: null,
          district: null,
          city: null,
          city_id: null,
          state_short: null
        },
        complement: null,
        number: null
      }
    },
    methods: {
      cepData(data) {
        this.cep = data
      },
      addressLoad() {
        this.$api
            .get(this.endpoint_load)
            .then(response => {
              this.id = response.data.id;
              this.complement = response.data.complement;
              this.number = response.data.number;
              this.cep = {
                zipcode: response.data.zipcode,
                street: response.data.street,
                district: response.data.district,
                city: response.data.city,
                state_short: response.data.state_short,
              }
            });
      },
      addressEdit() {
        this.editState = true;

        let payload = {
          id: this.id,
          zipcode: this.cep.zipcode,
          street: this.cep.street,
          complement: this.complement ? this.complement : '',
          number: this.number ? this.number : '',
          district: this.cep.district,
          city_id: this.cep.city_id
        }

        payload = {...payload, ...this.payload};

        if (this.credential) {
          payload.credential = this.$router.currentRoute.params.project_id;
        }

        this.$api
            .post(this.endpoint_edit, payload)
            .then(response => {
              this.errors = [];
              this.id = response.data.id;
              if (this.credential) {
                this.$emit('Step', 4);
              } else {
                this.$root.$emit('GlobalSnackbar', {type: 'success', message: 'Endereço salvo'});
              }
            })
            .catch((error) => {
              this.errors = error.response.data.errors;
            })
            .finally(() => {
              this.editState = false;
            });
      }
    }
  }
</script>

<style>
</style>
